import * as Tooltip from '@radix-ui/react-tooltip';
import { MouseEvent, forwardRef } from 'react';

import { useTranslation } from '@lichtblick/i18next';
import { Colors, TextVariants } from '@lichtblick/theme';

import { StyledBaseButton } from './IconButton.styles';

import { TooltipContent } from '../CopyButton/CopyButton.styles';
import { Text } from '../Text';

export type IconButtonProps = {
  icon: React.ReactElement;
  isDisabled?: boolean;
  isOutlined?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  size?: 'large' | 'small';
  tooltip?: string;
  variant?: 'primary' | 'secondary' | 'ghost' | 'secondary-outlined' | 'rejection' | 'transparent';
};

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { icon, isDisabled, isOutlined = false, size = 'large', tooltip, variant = 'primary', ...rest }: IconButtonProps,
    forwardedRef,
  ) => {
    const { t } = useTranslation();

    return (
      <Tooltip.Provider delayDuration={0}>
        <Tooltip.Root>
          <Tooltip.Trigger asChild onClick={(e) => e.preventDefault()}>
            <StyledBaseButton
              $isOutlined={isOutlined}
              $size={size}
              $variant={variant}
              disabled={isDisabled}
              {...rest}
              ref={forwardedRef}
            >
              {icon}
            </StyledBaseButton>
          </Tooltip.Trigger>
          <Tooltip.Portal>
            {tooltip && (
              <TooltipContent asChild onPointerDownOutside={(e) => e.preventDefault()}>
                <Text $variant={TextVariants.button.s} color={Colors.white}>
                  {t(tooltip)}
                </Text>
              </TooltipContent>
            )}
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    );
  },
);
